import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { Typography } from 'shared/ui'
import { useSearchDropdownContext } from 'widgets/SearchDropdown/context/searchDropdownContext'

export type IEnrollmentSearchTriggerProps = {
  open?: boolean
}

export const EnrollmentSearchTrigger: FC<IEnrollmentSearchTriggerProps> = observer(() => {
  const store = useSearchDropdownContext()

  return (
    <TextFieldPlaceholder
      variant='stroke'
      size='small'
      leftActions={[
        makeTextFieldIcon({
          icon: 'search',
        }),
      ]}
      placeholder={
        <Typography
          variant={'text-input-field-r'}
          color={'var(--content-primary-disabled)'}
          ariaLabel={'placeholder'}
          ellipsis
          tag={'div'}
        >
          {store.placeholder}
        </Typography>
      }
    />
  )
})
